import { configureStore } from '@reduxjs/toolkit';
import balanceReducer from './balanceSlice';
import userReducer from './userSlice';
import liveStreamingReducer from './liveStreamingSlice';
import liveChatReducer from './liveChatSlice';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import searchReducer from './searchSlice';
import oddReducer from './oddSlice';
import hotEventReducer from './hotEventSlice';
import cartReducer from './cartSlice';
import betReducer from './betSlice';
import favoriteReducer from './favoriteSlice';
import myAccountReducer from './myAccount';
import loginModalReducer from './loginModalSlice';
import forecastReducer from './forecastSlice';
import settingsReducer from './settingSlice';
import uiReducer from './uiSlice';

const store = configureStore({
  devTools: false,
  reducer: {
    balance: balanceReducer,
    user: userReducer,
    liveStreaming: liveStreamingReducer,
    liveChat: liveChatReducer,
    search: searchReducer,
    odd: oddReducer,
    hotEvent: hotEventReducer,
    cart: cartReducer,
    bet: betReducer,
    favorite: favoriteReducer,
    myAccount: myAccountReducer,
    loginModal: loginModalReducer,
    forecast: forecastReducer,
    setting: settingsReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
